// Long-form article content, bilingual (ES / EN).
// Keyed by slug. The Virgo Cluster card on the landing page links to /articles/virgo-cluster.

export const articles = {
  "scopelink-experience-el-hierro": {
    slug: "scopelink-experience-el-hierro",
    image: "https://img.youtube.com/vi/-wLhxg4us4s/maxresdefault.jpg",
    ES: {
      category: "Experiencia",
      dateLabel: "27 JUL · 2026",
      date: "2026-07-27",
      readTime: "4 min",
      author: "Equipo Scopelink",
      title: "Así se siente operar un observatorio real con Scopelink",
      lead:
        "No se trata solo de descargar imágenes: se trata de operar un observatorio real. En este vídeo mostramos una experiencia Scopelink desde El Hierro, bajo uno de los cielos más oscuros del mundo.",
      blocks: [
        {
          type: "video",
          src: "https://www.youtube-nocookie.com/embed/-wLhxg4us4s",
          title: "La experiencia Scopelink: operación de un observatorio remoto en El Hierro",
        },
        { type: "h2", text: "El observatorio, estés donde estés" },
        {
          type: "p",
          text: "Controlar un telescopio a distancia debería sentirse tan natural como estar junto a él. El vídeo ofrece un vistazo a una sesión real desde El Hierro, en las Islas Canarias, y muestra cómo Scopelink acerca el observatorio completo al usuario.",
        },
        { type: "h2", text: "Para astrofotógrafos y propietarios" },
        {
          type: "p",
          text: "Los astrofotógrafos pueden acceder a cielos más oscuros sin renunciar al control de su equipo. Al mismo tiempo, los propietarios de observatorios pueden compartir su infraestructura de manera segura y gestionada, manteniendo claros los accesos y permisos de cada persona.",
        },
        { type: "h2", text: "Astronomía remota, simple y accesible" },
        {
          type: "p",
          text: "Scopelink está diseñado para eliminar fricción de la astronomía remota. Equipos, monitorización y accesos conviven en una experiencia clara para que el foco siga donde debe estar: en observar, capturar y disfrutar del cielo.",
        },
        {
          type: "callout",
          label: "Descubre Scopelink",
          text: "Reserva una demo gratuita y descubre cómo operar o compartir tu observatorio con Scopelink.",
        },
      ],
      backToNews: "Volver a Novedades",
      cta: "Reservar una demo",
      shareLabel: "Compartir",
    },
    EN: {
      category: "Experience",
      dateLabel: "JUL 27 · 2026",
      date: "2026-07-27",
      readTime: "4 min",
      author: "Scopelink Team",
      title: "What It Feels Like to Operate a Real Observatory with Scopelink",
      lead:
        "You are not just downloading images: you are operating a real observatory. In this video, we share a glimpse of the Scopelink experience from El Hierro, beneath some of the darkest skies in the world.",
      blocks: [
        {
          type: "video",
          src: "https://www.youtube-nocookie.com/embed/-wLhxg4us4s",
          title: "The Scopelink experience: operating a remote observatory on El Hierro",
        },
        { type: "h2", text: "Your observatory, wherever you are" },
        {
          type: "p",
          text: "Controlling a telescope remotely should feel as natural as standing beside it. The video offers a look at a real session from El Hierro in the Canary Islands and shows how Scopelink brings the complete observatory within reach.",
        },
        { type: "h2", text: "For astrophotographers and observatory owners" },
        {
          type: "p",
          text: "Astrophotographers can reach darker skies without giving up control of their equipment. At the same time, observatory owners can share their infrastructure in a secure, managed way, with clear access and permissions for every person.",
        },
        { type: "h2", text: "Remote astronomy made simple and accessible" },
        {
          type: "p",
          text: "Scopelink is designed to remove friction from remote astronomy. Equipment, monitoring, and access come together in one clear experience, keeping the focus where it belongs: observing, capturing, and enjoying the sky.",
        },
        {
          type: "callout",
          label: "Discover Scopelink",
          text: "Book a free demo and discover how to operate or share your observatory with Scopelink.",
        },
      ],
      backToNews: "Back to News",
      cta: "Book a free demo",
      shareLabel: "Share",
    },
  },
  ecosystem: {
    slug: "ecosystem",
    image:
      "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85",
    ES: {
      category: "Plataforma",
      dateLabel: "14 JUN · 2026",
      date: "2026-09-14",
      readTime: "6 min",
      author: "Equipo Scopelink",
      title: "Integrando el ecosistema del observatorio",
      lead:
        "Un observatorio remoto moderno no se compone de un único dispositivo. Es un ecosistema de telescopios, cámaras, monturas, estaciones meteorológicas, sistemas de alimentación, safety monitors, equipos de red y controladores de automatización. Scopelink.io está diseñado para reunir todos esos elementos bajo una capa de gestión común, ayudando a propietarios y equipos de observatorios a operar su infraestructura de forma más segura, clara y escalable.",
      blocks: [
        {
          type: "h2",
          text: "Dispositivos y protocolos compatibles",
        },
        {
          type: "p",
          text:
            "Scopelink.io puede integrarse con dispositivos y servicios habituales en instalaciones astronómicas reales. Las estaciones meteorológicas que utilizan el protocolo Weather Underground pueden aportar datos de viento, humedad, temperatura y lluvia. Las cámaras que exponen endpoints RTSP o HTTP pueden añadirse para monitorización en vivo. Medidores de calidad de cielo como TESS, sensores de nubes como CloudWatcher Solo, sistemas SAI (UPS) conectados por USB, relés inteligentes y medidores de consumo como los dispositivos Shelly, y otros componentes locales de automatización pueden formar parte del mismo entorno operativo.",
        },
        {
          type: "h2",
          text: "Casos de uso reales",
        },
        {
          type: "p",
          text:
            "Esta compatibilidad es útil en muchos escenarios: un astrofotógrafo particular que gestiona su propio observatorio remoto, una asociación de astronomía que comparte equipamiento entre socios, un observatorio educativo que ofrece acceso supervisado a estudiantes o un centro de telescope hosting que administra varias configuraciones de clientes. En todos esos casos el reto es similar: diferentes personas necesitan acceder a dispositivos distintos, en momentos distintos y con niveles de permiso diferentes.",
        },
        {
          type: "h2",
          text: "Un entorno gestionado, no un conjunto de herramientas sueltas",
        },
        {
          type: "p",
          text:
            "En lugar de tratar cada sistema como una herramienta aislada, Scopelink.io ayuda a organizar el observatorio como un entorno gestionado. Los dispositivos pueden monitorizarse, los permisos pueden concederse, los accesos pueden limitarse y la información de seguridad puede sustentar las decisiones operativas.",
        },
        {
          type: "h2",
          text: "Conectar, proteger y simplificar",
        },
        {
          type: "p",
          text:
            "El objetivo no es sustituir al software o al hardware astronómico especializado, sino conectarlo, proteger su acceso y hacer que todo el observatorio sea más fácil de gestionar — ya pertenezca a una empresa, a una asociación, a un centro educativo o a un astrofotógrafo individual.",
        },
        {
          type: "callout",
          label: "Tu observatorio, integrado",
          text:
            "¿Tienes equipos que no aparecen en esta lista? Cuéntanoslo: nuestro objetivo es integrar el observatorio real, no uno teórico.",
        },
      ],
      backToNews: "Volver a Novedades",
      cta: "Hablar con un ingeniero",
      shareLabel: "Compartir",
    },
    EN: {
      category: "Platform",
      dateLabel: "JUN 14 · 2026",
      date: "2026-06-14",
      readTime: "6 min",
      author: "Scopelink Team",
      title: "Integrating the Observatory Ecosystem",
      lead:
        "A modern remote observatory is not made of a single device. It is an ecosystem of telescopes, cameras, mounts, weather stations, power systems, safety monitors, network devices and automation controllers. Scopelink.io is designed to bring all those elements together under a common management layer, helping observatory owners and teams operate their infrastructure in a safer, clearer and more scalable way.",
      blocks: [
        {
          type: "h2",
          text: "Supported devices and protocols",
        },
        {
          type: "p",
          text:
            "Scopelink.io can integrate with devices and services commonly found in real astronomical installations. Weather stations using the Weather Underground protocol can provide wind, humidity, temperature and rain data. Cameras exposing RTSP or HTTP endpoints can be added for live monitoring. Sky quality meters such as TESS, cloud sensors such as CloudWatcher Solo, USB-connected UPS systems, smart relays and power meters such as Shelly devices, and other local automation components can all become part of the same operational environment.",
        },
        {
          type: "h2",
          text: "Real-world scenarios",
        },
        {
          type: "p",
          text:
            "This compatibility is useful in many scenarios: a private astrophotographer managing a personal remote observatory, an astronomy association sharing equipment between members, an educational observatory giving supervised access to students, or a telescope hosting facility managing several customer setups. In all these cases, the challenge is similar: different people may need access to different devices, at different times, with different levels of permission.",
        },
        {
          type: "h2",
          text: "A managed environment, not a pile of tools",
        },
        {
          type: "p",
          text:
            "Instead of treating each system as an isolated tool, Scopelink.io helps organize the observatory as a managed environment. Devices can be monitored, permissions can be granted, access can be limited, and safety information can support operational decisions.",
        },
        {
          type: "h2",
          text: "Connect, protect, and simplify",
        },
        {
          type: "p",
          text:
            "The goal is not to replace specialized astronomical software or hardware, but to connect it, protect access to it, and make the whole observatory easier to manage — whether it belongs to a company, an association, a school, or an individual astrophotographer.",
        },
        {
          type: "callout",
          label: "Your observatory, integrated",
          text:
            "Have devices that aren't on this list? Tell us about them — our goal is to integrate the real observatory, not a theoretical one.",
        },
      ],
      backToNews: "Back to News",
      cta: "Talk to an engineer",
      shareLabel: "Share",
    },
  },
  pam: {
    slug: "pam",
    image:
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85",
    ES: {
      category: "Seguridad",
      dateLabel: "08 APR · 2026",
      date: "2026-04-08",
      readTime: "7 min",
      author: "Equipo Scopelink",
      title: "Privileged Access Management para observatorios remotos",
      lead:
        "Privileged Access Management, o PAM, es un paradigma de seguridad centrado en controlar, limitar y auditar el acceso a sistemas críticos. En lugar de entregar a los usuarios contraseñas permanentes o accesos amplios a la infraestructura, PAM concede únicamente el nivel de acceso necesario, sólo durante el tiempo requerido y sólo al recurso concreto en cuestión.",
      blocks: [
        {
          type: "h2",
          text: "Por qué importa PAM",
        },
        {
          type: "p",
          text:
            "En entornos IT tradicionales, PAM se utiliza habitualmente para proteger servidores, sistemas industriales, plataformas cloud, bases de datos y cuentas de administrador. Su propósito es sencillo: reducir el riesgo. Las contraseñas compartidas, los accesos remotos descontrolados y las credenciales permanentes generan problemas de seguridad, confusión operativa y falta de trazabilidad. PAM sustituye ese modelo por sesiones controladas, permisos temporales, trazabilidad y gobierno centralizado.",
        },
        {
          type: "h2",
          text: "Relevancia en observatorios remotos",
        },
        {
          type: "p",
          text:
            "Este enfoque es especialmente relevante para los observatorios remotos y los centros de telescope hosting. Un observatorio puede integrar telescopios, monturas, cámaras, cúpulas, techos rodantes, estaciones meteorológicas, sistemas de seguridad, controladores de alimentación y escritorios remotos. A estos sistemas suelen acceder clientes, técnicos, operadores, estudiantes o colaboradores externos. Sin un modelo de acceso adecuado, resulta difícil saber quién puede hacer qué, cuándo y bajo qué condiciones.",
        },
        {
          type: "h2",
          text: "Aplicado a la gestión de observatorios",
        },
        {
          type: "p",
          text:
            "Aplicado a la gestión de observatorios, PAM permite que cada usuario reciba permisos precisos: acceso a un telescopio durante una sesión reservada, control de una cámara concreta, acceso a un escritorio remoto o privilegios de técnico para tareas de mantenimiento. Estos permisos pueden ser temporales, programados, revocados automáticamente y limitados por rol o por dispositivo.",
        },
        {
          type: "h2",
          text: "Una nueva profesionalidad para el telescope hosting",
        },
        {
          type: "p",
          text:
            "Para los proveedores de telescope hosting, PAM convierte el acceso remoto en un servicio profesional, en lugar de un acuerdo informal basado en la confianza y en credenciales compartidas. Mejora la seguridad, simplifica las operaciones, habilita la auditoría y hace posible escalar desde un único observatorio hasta una red de instalaciones astronómicas hospedadas con total garantía.",
        },
        {
          type: "callout",
          label: "Cómo lo aplica Scopelink",
          text:
            "Scopelink.io trae PAM al mundo de la astronomía: accesos por usuario, sesiones programadas, permisos revocables al instante y auditoría completa sobre cada dispositivo del observatorio.",
        },
      ],
      backToNews: "Volver a Novedades",
      cta: "Hablar con un ingeniero",
      shareLabel: "Compartir",
    },
    EN: {
      category: "Security",
      dateLabel: "APR 08 · 2026",
      date: "2026-04-08",
      readTime: "7 min",
      author: "Scopelink Team",
      title: "Privileged Access Management for Remote Observatories",
      lead:
        "Privileged Access Management, or PAM, is a security paradigm focused on controlling, limiting, and auditing access to critical systems. Instead of giving users permanent passwords or broad access to infrastructure, PAM grants the right level of access only when it is needed, only for the required time, and only to the specific resource involved.",
      blocks: [
        {
          type: "h2",
          text: "Why PAM matters",
        },
        {
          type: "p",
          text:
            "In traditional IT environments, PAM is commonly used to protect servers, industrial systems, cloud platforms, databases, and administrator accounts. Its purpose is simple: reduce risk. Shared passwords, uncontrolled remote access, and permanent credentials create security problems, operational confusion, and a lack of accountability. PAM replaces that model with controlled sessions, temporary permissions, traceability, and centralized governance.",
        },
        {
          type: "h2",
          text: "Why it matters for remote observatories",
        },
        {
          type: "p",
          text:
            "This approach is especially relevant for remote observatories and telescope hosting facilities. An observatory may include telescopes, mounts, cameras, domes, roll-off roofs, weather stations, safety systems, power controllers, and remote desktops. These systems are often accessed by customers, technicians, operators, students, or external collaborators. Without a proper access model, it becomes difficult to know who can do what, when, and under which conditions.",
        },
        {
          type: "h2",
          text: "Applied to observatory management",
        },
        {
          type: "p",
          text:
            "Applied to observatory management, PAM allows each user to receive precise permissions: access to a telescope during a booked session, control of a specific camera, access to a remote desktop, or technician privileges for maintenance. These permissions can be temporary, scheduled, revoked automatically, and limited by role or device.",
        },
        {
          type: "h2",
          text: "A new level of professionalism for telescope hosting",
        },
        {
          type: "p",
          text:
            "For telescope hosting providers, PAM turns remote access into a professional service instead of an informal arrangement based on trust and shared credentials. It improves security, simplifies operations, enables auditing, and makes it possible to scale from a single observatory to a network of hosted astronomical facilities with confidence.",
        },
        {
          type: "callout",
          label: "How Scopelink applies it",
          text:
            "Scopelink.io brings PAM to astronomy: per-user access, scheduled sessions, instantly revocable permissions, and full auditing across every observatory device.",
        },
      ],
      backToNews: "Back to News",
      cta: "Talk to an engineer",
      shareLabel: "Share",
    },
  },
  "virgo-cluster": {
    slug: "virgo-cluster",
    image:
      "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85",
    ES: {
      category: "Lanzamiento",
      dateLabel: "20 MAY · 2026",
      date: "2026-05-20",
      readTime: "6 min",
      author: "Equipo Scopelink",
      title: "Gestión de clusters de observatorios en Scopelink.io",
      lead:
        "Scopelink.io ofrece una capa de gestión diseñada para centros de hospedaje de telescopios y redes de observatorios remotos. Su objetivo principal es ayudar a los operadores a administrar varios observatorios como un único cluster coordinado, manteniendo el acceso seguro, controlado y fácil de operar.",
      blocks: [
        {
          type: "p",
          text:
            "En un entorno de telescope hosting, cada observatorio puede contener dispositivos diferentes: telescopios, monturas, cámaras, estaciones meteorológicas, all-sky cameras, safety monitors, sistemas de alimentación, cúpulas, techos rodantes, escritorios remotos y otros equipos de automatización. Scopelink.io permite organizar y compartir estos recursos entre observatorios cuando sea necesario, sin perder el control sobre quién puede acceder a ellos y cuándo.",
        },
        {
          type: "h2",
          text: "Gestión centralizada de cluster",
        },
        {
          type: "p",
          text:
            "La gestión de cluster permite definir observatorios, usuarios, dispositivos y permisos desde una plataforma central. Por ejemplo, un operador puede conceder a un cliente acceso a un telescopio concreto, autorizar a un técnico a operar el sistema de techo o permitir que otro observatorio comparta los datos meteorológicos y de seguridad. Los permisos pueden ser temporales, limitados a una sesión planificada, o restringidos a dispositivos y acciones específicas.",
        },
        {
          type: "h2",
          text: "Pensado para telescope hosting profesional",
        },
        {
          type: "p",
          text:
            "Esto resulta especialmente útil en centros de telescope hosting profesionales o semiprofesionales, donde varios usuarios pueden alquilar, compartir u operar remotamente equipos hospedados en distintas ubicaciones. En lugar de depender de contraseñas compartidas, accesos a escritorio remoto informales o coordinación manual, Scopelink.io ofrece una forma estructurada de gestionar accesos, automatización y trazabilidad.",
        },
        {
          type: "h2",
          text: "Una nueva forma de escalar el hosting astronómico",
        },
        {
          type: "p",
          text:
            "Al tratar los observatorios como parte de un cluster gestionado, los proveedores de hospedaje pueden escalar sus operaciones, ofrecer un acceso remoto más seguro a sus clientes, simplificar el soporte técnico y crear nuevos modelos de negocio en torno a la infraestructura astronómica compartida. Scopelink.io está construido para hacer que el telescope hosting sea más profesional, más seguro y comercialmente viable.",
        },
        {
          type: "callout",
          label: "Plan recomendado",
          text:
            "Todo esto está incluido en el plan Virgo Cluster. Hablemos sobre cómo estructurar tu red de observatorios.",
        },
      ],
      backToNews: "Volver a Novedades",
      cta: "Hablar con un ingeniero",
      shareLabel: "Compartir",
    },
    EN: {
      category: "Release",
      dateLabel: "MAY 20 · 2026",
      date: "2026-05-20",
      readTime: "6 min",
      author: "Scopelink Team",
      title: "Observatory Cluster Management in Scopelink.io",
      lead:
        "Scopelink.io provides a management layer designed for telescope hosting facilities and networks of remote observatories. Its main goal is to help operators manage multiple observatories as part of a single coordinated cluster, while keeping access secure, controlled, and easy to operate.",
      blocks: [
        {
          type: "p",
          text:
            "In a telescope hosting environment, each observatory may contain different devices: telescopes, mounts, cameras, weather stations, all-sky cameras, safety monitors, power systems, domes, roll-off roofs, remote desktops, and other automation equipment. Scopelink.io allows these resources to be organized and shared between observatories when needed, without losing control over who can access them and when.",
        },
        {
          type: "h2",
          text: "Centralized cluster management",
        },
        {
          type: "p",
          text:
            "Cluster management makes it possible to define observatories, users, devices, and permissions from a central platform. For example, an operator can grant a customer access to a specific telescope, allow a technician to operate a roof system, or let another observatory share weather and safety data. Permissions can be temporary, limited to a scheduled session, or restricted to specific devices and actions.",
        },
        {
          type: "h2",
          text: "Built for professional telescope hosting",
        },
        {
          type: "p",
          text:
            "This is especially useful for professional or semi-professional telescope hosting sites, where several users may rent, share, or remotely operate equipment hosted in different locations. Instead of relying on shared passwords, informal remote desktop access, or manual coordination, Scopelink.io provides a structured way to manage access, automation, and accountability.",
        },
        {
          type: "h2",
          text: "A new way to scale astronomical hosting",
        },
        {
          type: "p",
          text:
            "By treating observatories as part of a managed cluster, hosting providers can scale their operations, offer safer remote access to customers, simplify technical support, and create new business models around shared astronomical infrastructure. Scopelink.io is built to make telescope hosting more professional, secure, and commercially viable.",
        },
        {
          type: "callout",
          label: "Recommended plan",
          text:
            "All of this is included in the Virgo Cluster plan. Let's talk about how to structure your observatory network.",
        },
      ],
      backToNews: "Back to News",
      cta: "Talk to an engineer",
      shareLabel: "Share",
    },
  },
};
